export default function Card({ title, actions, children, ...rest }) {
  return (
    <div class="card" {...rest}>
      {title && (
        <div class="card-header">
          <h3 class="card-title">{title}</h3>
          {actions && <div class="card-actions">{actions}</div>}
        </div>
      )}
      <div class="card-body">{children}</div>
    </div>
  );
}
